import { extractedClientNameFromURL } from "./extractClientNameFromURL";

export const getJobBoardClientNameFromLocalStorage = (): string => {
    let storedJobBoardClientName = localStorage.getItem('jobBoardClientName');

    
    if (!storedJobBoardClientName) {
        storedJobBoardClientName = extractedClientNameFromURL();
    }
    
    return storedJobBoardClientName || '';
}